import * as React from 'react';
import { useEffect, useState } from 'react';

import safeEnableAdsTracking from 'bundles/event-tracking/safeEnableAdsTracking';

const withMarketingScripts = <P extends Record<string, unknown>>(Component: React.ComponentType<P>) => {
  const WithPageLoaded = (props: P) => {
    const [isAdsTrackingEnabled, setAdsTracking] = useState(false);

    const enableAdsTracking = (timeout = 1000) => {
      if (!isAdsTrackingEnabled) {
        setAdsTracking(true);
        // As a general buffer, wait one sec before enabling ad tracking.
        setTimeout(() => {
          safeEnableAdsTracking();
        }, timeout);
      }
    };

    const checkForPerformanceTimings = () => {
      if (!isAdsTrackingEnabled) {
        if (window && window.performance?.timing?.loadEventEnd > 0) {
          enableAdsTracking(5000);
        } else {
          setTimeout(checkForPerformanceTimings, 100);
        }
      }
    };

    useEffect(() => {
      // Only add our marketing scripts when user has interacted with the page.
      // This is safe way to ensure our TTI doesn't get hammered by all of our marketing scripts loading on page load.
      window.addEventListener('scroll', () => enableAdsTracking(), { once: true });

      window.addEventListener('click', () => enableAdsTracking(), { once: true });

      // As a catch, check for window.performance.timing.loadEventEnd (page is completely done loading) to add tracking tags.
      checkForPerformanceTimings();
    });

    return <Component {...props} />;
  };

  return WithPageLoaded;
};

export default withMarketingScripts;
